export default __webpack_public_path__ + "static/media/swinburne-tooltip.9cb6c353.png";